var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoginBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 65,
    viewBox: "0 0 50 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4986 16.0886H22.3298M39.4986 40.0228H10.126M39.4987 24.0667H22.3298M39.4986 32.0447H22.3298M22.8424 3H47V55.1156L41.4555 62.1707L36 55.1156L30.4555 62.1707L24.9999 55.1156L19.4556 62.1707L14 55.1156L8.45555 62.1707L3 55.1156V3H11.6482H22.8424Z",
    stroke: "white",
    strokeWidth: 4.94689,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoginBilling);
export default __webpack_public_path__ + "static/media/Icon_Login_Billing.caf316b6eb0cc479e162ffbef39d37f7.svg";
export { ForwardRef as ReactComponent };